// extracted by mini-css-extract-plugin
export default {"card":"Card_card__1Zv52","right":"Card_right__RvZC2","title":"Card_title__8yYSZ","description":"Card_description__S8xpZ"};